var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5596 1.31859L10.6804 0.439453C10.3877 0.146484 10.0038 0 9.6199 0C9.23599 0 8.85208 0.146484 8.55912 0.439219L0.300218 8.69812L0.00256245 11.3752C-0.0349375 11.7122 0.230609 12 0.560374 12C0.581234 12 0.602093 11.9988 0.623421 11.9965L3.29857 11.7009L11.5598 3.43969C12.1455 2.85398 12.1455 1.9043 11.5596 1.31859ZM2.95428 10.9847L0.77389 11.2263L1.0167 9.04266L7.20162 2.85773L9.14154 4.79766L2.95428 10.9847ZM11.0294 2.90953L9.67169 4.26727L7.73177 2.32734L9.08951 0.969609C9.23107 0.828047 9.41951 0.75 9.6199 0.75C9.82029 0.75 10.0085 0.828047 10.1503 0.969609L11.0294 1.84875C11.3217 2.14125 11.3217 2.61703 11.0294 2.90953Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a956781e.svg";
export { ForwardRef as ReactComponent };